<aside class="admin-side">
  <div class="admin-brand">
    <div class="admin-mark">T</div>
    <div>
      <div class="admin-title">Trexa Admin</div>
      <div class="admin-sub">Platform console</div>
    </div>
  </div>

  <nav class="admin-navv" #navEl>
    <a class="anav"
       *ngFor="let item of items"
       [routerLink]="item.path"
       routerLinkActive="on">
      <span class="ni" [ngSwitch]="item.iconKey">
        <svg *ngSwitchCase="'grid'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
        <svg *ngSwitchCase="'store'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l1.5-5h15L21 9M4 9h16v11H4zM9 20v-6h6v6"/></svg>
        <svg *ngSwitchCase="'people'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>
        <svg *ngSwitchCase="'wallet'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="15" rx="2"/><path d="M2 10h20M16 15h.01"/></svg>
        <svg *ngSwitchCase="'card'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 9h20M6 15h4"/></svg>
        <svg *ngSwitchCase="'whatsapp'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a9 9 0 0 0-7.8 13.5L3 21l4.7-1.2A9 9 0 1 0 12 3z"/><path d="M8.3 8.7c.2-.5.5-.5.8-.5h.6c.2 0 .4 0 .6.4.2.5.7 1.7.7 1.8.1.1.1.3 0 .4-.5 1-1 .9-.6 1.5.8 1.2 1.5 1.6 2.6 2.1.2.1.3.1.5-.1.2-.2.7-.8.9-1.1.2-.2.3-.2.6-.1.2.1 1.5.7 1.8.8.2.1.4.2.4.3 0 .5-.2 1.2-.6 1.6-.4.4-1.2.7-1.9.7-.6 0-1.6-.2-3.3-1.1-2.6-1.4-4.1-4.1-4.2-4.3-.1-.2-.9-1.3-.9-2.4 0-1.1.6-1.7.8-1.9z"/></svg>
      </span>
      <span>{{ item.label }}</span>
    </a>
  </nav>

  <div class="admin-side-foot">
    <!-- Mirrors the vendor "Managing" mecard styling, for the admin persona. -->
    <div class="mecard">
      <div class="lab">Signed in as</div>
      <div class="nm">{{ adminLabel() }}</div>
      <div class="sub">Platform administrator</div>
      <button class="sw-btn" (click)="logout()">Log out</button>
    </div>
  </div>
</aside>
